import { faArrowLeft, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANTS from '../../constants';
import TimeHelper from '../../helpers/TimeHelper';
import AnalyticsService from '../../services/AnalyticsService';

class Intro extends Component {
  fireBaseEvent(eventName) {
    AnalyticsService.logEvent(eventName, {
      category: CONSTANTS.EVENTS.MENU.GROUP_NAME,
      locationId: this.props.location.slug
    });
    return true;
  }

  render() {
    let showBackButton;
    if (this.props.location && this.props.location.state)
      showBackButton = this.props.location.state.showBackButton;
    let { _location } = this.props;
    if (this.props.grid_layout !== 'old') {
      return (
        <div className={'intro-main'}>
          <div className="intro p-md-0 ps-md-3 f0 header-font-1">
            {showBackButton && (
              <FontAwesomeIcon
                className="mr-3"
                size={'sm'}
                icon={faArrowLeft}
                onClick={this.props.goBack}
                color='var(--header-font1-color)'
              />
            )}
            <h3 className='header-font-1'>{_location.name}</h3>
            {/* {_location?.category_name &&
                    <div className={"circle-dot"}></div>}
                    {_location?.category_name &&
                    <h4>{_location.category_name}</h4>} */}
          </div>
          <h3 className={'opening-closing-time header-font-1'}>
            <FontAwesomeIcon
              size={'sm'}
              icon={faClock}
              color='var(--header-font1-color)'
            />
            {' '}
            {TimeHelper.getOpeningHours(_location, moment().isoWeekday())}
          </h3>
        </div>
      );
    } else if (this.props.grid_layout === 'old') {
      return (
        <div className="intro p-md-0 ps-md-3 f0 header-font-1">
          {showBackButton && (
            <FontAwesomeIcon
              className="mr-3"
              size={'sm'}
              icon={faArrowLeft}
              onClick={this.props.goBack}
              color='var(--header-font1-color)'
            />
          )}
          {_location.name}
        </div>
      );
    }
  }
}

export default withRouter(Intro);
